export default __webpack_public_path__ + "static/media/linkedin1.13035068.png";